import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
interface KlaraAvatarProps {
  /** Size in pixels. Defaults to 40. */
  size?: number;
  /** Ring style variant. "dark" for use on dark backgrounds, "light" for light backgrounds. */
  variant?: "dark" | "light";
}
export function KlaraAvatar(t0) {
  const $ = _c(6);
  const {
    size: t1,
    variant: t2
  } = t0;
  const size = t1 === undefined ? 40 : t1;
  const variant = t2 === undefined ? "dark" : t2;
  const sizeClass = size <= 32 ? "h-8 w-8" : size <= 40 ? "h-10 w-10" : size <= 48 ? "h-12 w-12" : "h-20 w-20";
  const ringClass = variant === "dark" ? "ring-2 ring-white/30" : "ring-4 ring-secondary-fixed/20";
  const t3 = `${sizeClass} rounded-[9999px] overflow-hidden ${ringClass}`;
  const t4 = `${sizeClass} rounded-[9999px] object-cover`;
  let t5;
  if ($[0] !== size || $[1] !== t4) {
    t5 = <Image src="/images/chat/klara.jpeg" alt="Klara" width={size} height={size} className={t4} />;
    $[0] = size;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t3 || $[4] !== t5) {
    t6 = <div className="shrink-0"><div className={t3}>{t5}</div></div>;
    $[3] = t3;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
}